import React, {Component} from 'react';
import { Button, Input, Grid, Header} from 'semantic-ui-react';
import {connect} from "react-redux";
import SaleData from "../../data/SaleData";
import {totalSale} from "../../actions/SaleTotalAction";
import {showToast} from "../../actions/ToastAction";

class DeliveryForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            delivery_price: props.total_sale.delivery_price,
            sending: false,
            disabled: true
        };
        
        this.handleDeliveryChange = this.handleDeliveryChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    };

    handleDeliveryChange = (event) => {
        let delivery_price = parseFloat(event.target.value);
        if (delivery_price >= 0) {
            this.setState({ delivery_price, delivery_error: false, disabled: false });
        } else {
            this.setState({ delivery_error: true, disabled: true });
        }
        if (delivery_price > this.props.delivery_price) {
            this.setState({ disabled: true });
        }
        if (event.target.value.trim() === '' || isNaN(delivery_price)) {
            this.setState({ delivery_error: true, disabled: true, delivery_price: '' });
        }
    };

    handleSave(){
        if (this.state.delivery_price >= 0) {
            this.setState({sending: true});
            if(this.props.sale.id){
                let data = { sale: this.props.sale.id, delivery_price: this.state.delivery_price};
                SaleData.delivery(data, (res) => {
                    if(res && res.update){
                        this.props.totalSale(res.data);
                        this.props.showToast({message: 'Valor del domicilio aplicado!', type: 'success'});
                    }else{
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, disabled:true});
                });
            }
        } else {
            this.setState({disabled:false});
        }
    };

    render() {
        return (
            <Grid centered divided columns={1}>
                <Grid.Column textAlign='center'>
                    <Header as='h4'>Valor Domicilio</Header>
                        <Input
                            fluid
                            placeholder='$'
                            value={this.state.delivery_price}
                            onChange={this.handleDeliveryChange}
                            error={this.state.delivery_error }
                        />
                </Grid.Column>
                <Grid.Row>
                    <Button onClick={this.handleSave} loading={this.state.sending} fluid disabled={this.state.disabled}>Guardar</Button>
                </Grid.Row>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        total_sale: state.get('total_sale'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        totalSale(total) {
            dispatch(totalSale(total))
        },
        showToast(data) {
            dispatch(showToast(data));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeliveryForm);




// WEBPACK FOOTER //
// ./src/components/sale/DeliveryForm.js